import React, { useEffect, useState } from 'react';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

const MistakeWord = (props) => {
  const [mistakeAreaDisplay, setMistakeAreaDisplay] = useState("none");
  const [displayContents, setDisplayContents] = useState("");
  useEffect(() => {
    if (props.judgeResulut === false) {
      // mistake
      setMistakeAreaDisplay("block");
    } else {
      setMistakeAreaDisplay("none");
    }
  }, [props.judgeResulut]);

  const mistakeWordsArea = css`
    position: absolute;
    top: 20vh;
    right: 20vw;
    display: ${mistakeAreaDisplay};
    width: 15vw;
    max-height: 500px;
    height: 100%;
    text-align: center;
    div {
      font-size: 1.5em;
      color: #ff2929;
    }
  `;

  useEffect(() => {
    const tmpArr = [];

    props.mistakeWordsArr.map((data, i) => {
      tmpArr.push(<p key={i}>{data}</p>);
    });
    setDisplayContents(tmpArr);
  }, [props.mistakeWordsArr]);

  return (
    <>

      <div css={mistakeWordsArea}>
        <h4>
          間違えている単語
        </h4>
        <div>
          {
            displayContents
          }
        </div>

      </div>
    </>
  )
}

export default MistakeWord
